(function ($, undefined) {

    'use strict';
    var session;
    var currPage;
    var header;
    var logForm;
    var logForgotForm;
    var logFormBtn;
    var logForgotBtn;
    var logForgotSendBtn;
    var logForgotCancelBtn;
    var panel1;
    var panel2;
    var logPopupClose;
    var dashboardLogout;

    var connectBtn;
    var openLoginCoreBtn;
    var connectWin;
    var loginFail;
    var responsiveMenu;
    
    var recaptchaKey = "6LcB2hUqAAAAAJKM4KosE-a9hR2_wtrYoUXDxLrs"; // Production
    var recaptchaReady = false;

    var renderCaptcha = function (){
        logFormBtn = $(".login-form-ctn .login-btn");

        var $render = $(".account_login_recaptcha");
        if ($render.length && typeof grecaptcha === "object") {
            grecaptcha.ready(function () {
                // recaptcha initiated
                recaptchaReady = true;
                // Begin render in each element
                $render.each(function () {
                    var _ = this;
                    var loginForm = $(_).closest(".login-form-ctn");
                    var widgetId = grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'size': 'invisible',
                        'badge': 'bottomleft',
                        'callback': function (response) {
                            //loginForm.find('.account_login_recaptcha_token').val(response);
                            loginCheckUp(loginForm);
                        }
                    });
                    loginForm.attr("data-widget-id", widgetId);
                });
                // Click event on login button
                logFormBtn.on("click", loginRecaptcha);
            });
        } else {
            // API not found, bind regular click and submit form
            logFormBtn.on("click", function(e) {
                loginCheckUp($(this).closest(".login-form-ctn"));
            });
        }
    };

    var loginRecaptcha = function (e) {
        e.preventDefault();
        var loginForm = $(this).closest(".login-form-ctn");
        grecaptcha.execute(loginForm.attr("data-widget-id"));
    };
    
    var loginCheckUp = function (logCtn) {
        formValidator.validateForm(logCtn);

        if (!logCtn.hasClass('has-error')) {
            console.log("submit "+logCtn.attr("data-widget-id"));
            var email = encodeURIComponent(logCtn.find('input[name="username"]').val());
            session.save("loginEmail", email, function (response) {
                if ($('.login-dashboard').length && header.hasClass('logo-only')) {
                    document.cookie = 'loginFromDashboard=true;max-age=' + (60 * 60 * 24 * 365);
                    session.save("logoutDashboard", true, function (response) {
                        logCtn.submit();
                    });
                } else {
                    logCtn.submit();
                }
            });
        } else if (recaptchaReady) {
            grecaptcha.reset(logCtn.attr("data-widget-id"));
        }
    };

    var loginForgot = function (e, b) {
        var btn = (b === undefined) ? $(this) : b;
        var action = btn.attr("data-action");
        if (action === 'left') {
            panel1.css("left", "-50%");
            panel2.css("left", "-50%");
        } else {
            panel1.css("left", "0");
            panel2.css("left", "0%");
        }
    };

    var loginForgotSend = function (event) {
        event.preventDefault();
        var btn = $(this);
        var panel = btn.closest(".login-forms-slide-2");
        formValidator.validateForm(panel);
        if (!panel.hasClass('has-error')) {
            var email = panel.find("input[name='email']").val();

            ajax("/action/forgotPassword?email=" + encodeURIComponent(email), function () {
                logForgotForm.fadeOut("fast", function () {
                    panel.find(".forgot-pwd-success").slideDown();
                    window.setTimeout(function () {
                        reset(event);
                    }, 4000);
                });
            }, true);
        }
    };

    var resetForgotPwd = function () {
        panel2.each(function () {
            $(this).find(".forgot-pwd-success").slideUp("fast", function () {
                logForgotForm.fadeIn();
                logForgotForm.find("input[name='email']").val("");
                logForgotForm.find(".input-ctn").removeClass("focused");
            });
        });
    };

    var reset = function (event) {
        loginForgot(event, logForgotCancelBtn);
        resetForgotPwd();
    };

    var reinit = function () {
        connectWin.slideUp();
        $(".overlay").removeClass("active");
        header.removeClass("site-header-connect");
        $(".open-login-btn", header).removeClass("active");
    };

    var openLoginWindow = function (e, b) {
        var btn = (b === undefined) ? $(this) : b;
        responsiveMenu = $(".site-header-menu-toggle-ham").is(":visible");
        if (!responsiveMenu) {
            toggleOverlay();
            if (btn.hasClass("active")) {
                if (window.pageYOffset === 0) {
                    header.removeClass("site-header-scroll");
                }
                header.removeClass("site-header-connect");
                btn.removeClass("active");
                connectWin.slideUp();
                session.save("loginEmail", null, function () {});
                // window.setTimeout(function() {
                //     login.reset();
                // }, 500);
            } else {
                header.addClass("site-header-scroll");
                header.addClass("site-header-connect");
                var t = header.outerHeight();
                connectWin.css("top", t + "px");
                connectWin.slideDown();
                btn.addClass("active");
            }
        } else {
            // $("#loginWindowResp").css("position", "absolute");
            $('body').css('position', 'fixed');
            openWindow("loginWindowResp", true);
        }
    };

    var closeLoginWindow = function () {
        $('body').removeAttr('style');
        closeWindow("loginWindowResp");
        session.save("loginEmail", null, function () {});
        window.setTimeout(function () {
            reset();
        }, 500);
    };

    var toggleOverlay = function () {
        var active = $(".overlay").hasClass("active");
        if (active) {
            $(".overlay").removeClass("active");
        } else {
            $(".overlay").addClass("active");
        }
    };


    var init = function (page, event) {
        currPage = $(page);
        renderCaptcha();
        session = Fw.component.models().session;

        header = $(".site-header");
        panel1 = $(".login-forms-slide-1");
        panel2 = $(".login-forms-slide-2");
        /*Listeners linked to login form*/

        /* Toggles connection window */
        connectWin = $("#loginWindow", header);
        connectBtn = $(".open-login-btn", header);
        connectBtn.on("click", openLoginWindow);

        /*Handling cases : 
         * login failed, open window again ; 
         * login successfull : delete the session variable
         * */
        var logged = false;
        loginFail = ($("#loginFail", header).val() !== '');
        if ($(".is-signed-in", page).length !== 0 && loginFail) {
            session.save("loginEmail", null, function () {});
            logged = true;
        }
        if (loginFail && !logged && !header.hasClass('logo-only')) {
            openLoginWindow(event, connectBtn);
        }

        openLoginCoreBtn = $(".login-core-btn", page);
        openLoginCoreBtn.on("click", function () {
            openLoginWindow(event, connectBtn);
        });

        logForm = $(".login-form-ctn", page);
        logForgotForm = $(".forgot-pwd-input-ctn", page);

        logForgotBtn = $(".form-forgot-pwd", page);
        logForgotBtn.on("click", loginForgot);

        logForgotSendBtn = $(".get-pwd-btn", page);
        logForgotSendBtn.on("click", loginForgotSend);

        logForgotCancelBtn = $(".get-pwd-cancel-btn", page);
        logForgotCancelBtn.on("click", loginForgot);

        logPopupClose = $("#loginWindowResp .popup-inner-close", page);
        logPopupClose.on("click", closeLoginWindow);


        dashboardLogout = $('.dashboard-logout', page);
        dashboardLogout.on('click', function () {
            document.cookie = 'loginFromDashboard=false;max-age=1';
        });

    };

    var login = Fw.component.export('login', {
        init: init,
        reset: reset,
        reinit: reinit
    });

})(jQuery);